/**
 * Debug utility for development-only console logging
 *
 * All debug methods are automatically stripped from production builds
 * by Webpack's dead code elimination during minification.
 *
 * Usage:
 *   import { debug } from '../utils/debug';
 *   debug.log('Score:', score);
 *   debug.warn('Performance issue');
 *   debug.error('Critical error:', error);
 */

const isDev = process.env.NODE_ENV === "development";

export const debug = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  /* Log error messages (always logged, even in production) */
  error: (...args) => {
    console.error(...args);
  },
  table: (...args) => {
    if (isDev) console.table(...args);
  },
  time: (label) => {
    if (isDev) console.time(label);
  },
  timeEnd: (label) => {
    if (isDev) console.timeEnd(label);
  },
  group: (label) => {
    if (isDev) console.group(label);
  },
  groupEnd: () => {
    if (isDev) console.groupEnd();
  },
};
